import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../../assets/text-helpers.scss';
import { FontSizes } from '../../../../../types/common/types';

export const templateReconfigureAgentTypeForm = document.createElement('template');

templateReconfigureAgentTypeForm.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div id='reconfigure-agent-operations-form-wrapper'>
    <div class='form-section'>
      <gz-form-field id='reconfigure-agent-operations-form-field' class='label-mw-150'>
        <gz-radio-group id='reconfigure-agent-operations-group' gz-form-input >
          <gz-radio id='reconfigure-agent-add-modules'></gz-radio>
          <gz-text fontSize='${FontSizes.PARAGRAPH_12}' class='mb-2 helper-text' id='reconfigure-agent-add-modules-description'></gz-text>
          <gz-radio class='pt-2' id='reconfigure-agent-remove-modules'></gz-radio>
          <gz-text fontSize='${FontSizes.PARAGRAPH_12}' class='mb-2 helper-text' id='reconfigure-agent-remove-modules-description'></gz-text>
          <gz-radio class='pt-2' id='reconfigure-agent-match-modules'></gz-radio>
          <gz-text fontSize='${FontSizes.PARAGRAPH_12}' class='mb-3 helper-text' id='reconfigure-agent-match-modules-description'></gz-text>
        </gz-radio-group>
      </gz-form-field>
    </div>
  </div>
`;
